module.exports = __webpack_public_path__ + "3b7ee275e9cab3b147f5795045d6aa85.svg";